// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nmUts","bodyWrapper":"styles_bodyWrapper__+CJRb","buttonNext":"styles_buttonNext__h+mzC"};